import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { useState } from "react";
import Modal1 from "../modals/Modal1";
import createDocApi from "../api/database/createDocApi";
import { files, folder } from "jszip";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import { EasySwitch } from "../textfields/EasySwitch";
import WarningButton from "../buttons/WarningButton";
import { getFlutterTime } from "../models/DataFunctions";
import UploadRapportSlot from "../api/upload/UploadRapportSlot";
import FactureSlotVisualisateur from "./FactureSlotVisualisateur";
import UploadFactureSlot from "../api/upload/UploadFactureSlot";
import SlotRapportVisualisateur from "./SlotRapportVisualisateur";
import { EditableInfoCell } from "../pages/folder_pages/folder_sidebar/FolderInformationSection";
import updateDocApi from "../api/database/updateDocApi";

const ReglementConstructor = ({
  orgData,
  userData,
  folderData,
  clientData,
  reglement,
  setReglement,
  slots,
  setSlots,

  handleUpdateReglement,
  handleFetchData,

  loadingTransfer,
  setLoadingTransfer,
  transferFiles,
  dropped_exists,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const theme = useTheme();

  const handleDeleteslot = async (index) => {
    if (slots[index].paid === true) {
      handleClickVariant(
        "Impossible de supprimer un paiement déjà payé",
        "error"
      );
      return;
    }
    // if only one slot left, prevent deletion is impossible
    if (slots.length === 1) {
      handleClickVariant(
        "Impossible de supprimer si il n'y a qu'un paiement",
        "error"
      );
      return;
    }
    let new_slots = slots.map((pay) => pay.ref).filter((_, i) => i !== index);
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement.slots",
      new_slots,
      prefix
    );
    await addActivityLog(
      "Paiement supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "payment_deleted",
      prefix
    );
    await deleteDocApi(slots[index].ref, prefix);
    setDeleteOpen(null);
    handleFetchData();
    handleClickVariant("Paiement supprimé", "success");
  };

  const handleTransferFiles = async (docId) => {
    setLoadingTransfer(docId);
    await transferFiles(docId);
    setLoadingTransfer(null);
  };

  const handleSetReglementDone = async () => {
    let new_state = folderData.reglement_state === "done" ? null : "done";
    await updateDocDataFieldApi(
      folderData.ref,
      "reglement_state",
      new_state,
      prefix
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "finalised_date",
      new_state === "done" ? getFlutterTime() : null,
      prefix
    );
    // When removing the marking, also clear the nested `reglement.state` so the
    // "paiement" chip (which reads reglement.state === "wait") doesn't stay
    // stuck — resetting reglement_state alone leaves the folder half-paid.
    if (new_state === null) {
      await updateDocDataFieldApi(
        folderData.ref,
        "reglement.state",
        null,
        prefix
      );
    }
    await addActivityLog(
      "Dossier finalisé",
      folderData.ref,
      orgData.id,
      userData.id,
      "folder_finalised",
      prefix
    );
    handleFetchData();
    handleClickVariant("Le dossier a été finalisé", "success");
  };

  const handleAddSlot = async () => {
    let data = {
      facture_file: null,
      folder_ref: folderData.ref,
      state: "locked",
      files: null,
    };
    let new_slot = await createDocApi("rapport_slot", data, prefix);

    let slots = folderData.rapport?.slots ? folderData.rapport.slots : [];
    slots.push(new_slot.ref);
    await addActivityLog(
      "Emplacement ajouté",
      folderData.ref,
      orgData.id,
      userData.id,
      "slot_added",
      prefix
    );
    await updateDocDataFieldApi(folderData.ref, "rapport.slots", slots, prefix);
    handleFetchData();
    handleClickVariant("Emplacement ajouté", "success");
  };

  const handleSync = async (index) => {
    await updateDocApi(
      slots[index].ref,
      {
        title: slots[index].title,
      },
      prefix
    );
    handleClickVariant("Emplacement synchronisé", "success");
  };

  const handleSetLocked = async (index) => {
    let new_state = slots[index].state === "locked" ? "unlocked" : "locked";
    await updateDocDataFieldApi(slots[index].ref, "state", new_state, prefix);
    await addActivityLog(
      "Emplacement " + (new_state === "locked" ? "Verrouillé" : "Déverrouillé"),
      folderData.ref,
      orgData.id,
      userData.id,
      new_state === "locked" ? "slot_lock" : "slot_unlock",
      prefix
    );
    handleFetchData();
    handleClickVariant(
      "L'emplacement a été " +
        (new_state === "locked" ? "Verrouillé" : "Déverrouillé"),
      "success"
    );
  };

  return (
    <div className="flex flex-col h-fit gap-2 justify-end items-start">
      <div className="flex flex-row h-fit gap-2 justify-end items-start w-full">
        {deleteOpen !== null && (
          <div className="absolute w-screen h-screen  z-10">
            <Modal1
              isOpen={deleteOpen != null}
              onClose={() => setDeleteOpen(null)}
            >
              <div className=" flex flex-col bg-white rounded-xl p-4">
                <div className="text-h2">
                  Voulez-vous vraiment supprimer cet élément ?
                </div>
                <div className="text-h3 text-shadow_50 my-4">
                  Cette action est irréversible. Elle entraîne la suppression
                  définitive de ces éléments.
                </div>
                <div className="text-h3 text-shadow_50 ">- Facture déposée</div>
                <div className="text-h3 text-shadow_50 ">
                  - Rapports déposés
                </div>
                <div className="text-h3 text-shadow_50 ">- Prix déposés</div>

                {!loadingDelete && (
                  <div className="flex flex-row justify-end gap-2 ">
                    <SecondaryButton onClick={() => setDeleteOpen(null)}>
                      Annuler
                    </SecondaryButton>
                    <WarningButton onClick={() => handleDeleteslot(deleteOpen)}>
                      Supprimer
                    </WarningButton>
                  </div>
                )}
                {loadingDelete && <SmallSpinner></SmallSpinner>}
              </div>
            </Modal1>
          </div>
        )}
      </div>
      <div className="border-1 border-shadow_10 h-fit rounded-lg flex flex-col p-1 gap-1 w-full">
        <div className="flex flex-col gap-1 text-h3 text-black h-fit p-1 ">
          Emplacement de rapports
          <div className="flex flex-col gap-2 p-1">
            {slots?.map((slot, index) => (
              <div
                key={index}
                className={`flex flex-col gap-1 relative border-1 text-h2 ${slots[index]?.state === "unlocked" ? "bg-teal-50 border-teal-300 " : "bg-slate-100 border-slate-300"}  rounded-xl p-2`}
              >
                <div className="  text-h3 w-full text-indigo-500  flex flex-row justify-between">
                  <EditableInfoCell
                    data={
                      slots[index].title !== null &&
                      slots[index].title !== undefined
                        ? slots[index].title
                        : "emplacement de rapport " + (index + 1).toString()
                    }
                    onChangeData={(e) => {
                      setSlots((prev) => {
                        let new_slots = [...prev];
                        new_slots[index].title = e.target.value;
                        return new_slots;
                      });
                    }}
                    orgData={orgData}
                    folderData={folderData}
                    handleSync={() => handleSync(index)}
                  ></EditableInfoCell>
                  <div className=" w-fit text-h3 text-shadow_10 ">
                    {slots[index]?.id}
                  </div>
                </div>
                <div className="flex flex-row gap-4 ">
                  <div className="flex flex-col gap-2 p-1 w-c200 min-w-c200">
                    <div className="text-h3 text-shadow_50 ">Facture</div>
                    {dropped_exists && (
                      <SecondaryButton
                        sx={{
                          backgroundColor: theme.palette.chart.line_blue,
                          color: theme.palette.forever.white,
                        }}
                        className="h-fit w-fit inset-0 shimmer rounded-2xl "
                        onClick={() =>
                          handleTransferFiles("facture-slot#" + index)
                        }
                        disabled={
                          loadingTransfer !== undefined &&
                          loadingTransfer !== null
                        }
                      >
                        <div>
                          <div className="flex flex-row gap-1 items-center">
                            {loadingTransfer === "facture-slot#" + index
                              ? "Transfert en cours ..."
                              : "Transférer ici"}
                            <SmallSpinner
                              loading={
                                loadingTransfer === "facture-slot#" + index
                              }
                              margin={0}
                              size={20}
                            />
                          </div>
                        </div>
                      </SecondaryButton>
                    )}
                    <div className="flex flex-row gap-2 ">
                      <div className="flex w-8 h-fit">
                        <UploadFactureSlot
                          folderId={folderData.id}
                          slot_id={slot.id}
                          onUpdate={handleFetchData}
                          prefix={prefix}
                        ></UploadFactureSlot>
                      </div>
                      {!slots[index]?.facture_file && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Pas de facture
                        </div>
                      )}
                      {slots[index]?.facture_file && (
                        <div className=" text-h4  text-shadow_50  w-fit break-words overflow-hidden text-ellipsis">
                          {slots[index]?.facture_file?.name}
                        </div>
                      )}
                    </div>
                    {slots[index]?.facture_file && (
                      <FactureSlotVisualisateur
                        folder={folderData}
                        slot_id={slots[index].id}
                        orgData={orgData}
                        prefix={prefix}
                      ></FactureSlotVisualisateur>
                    )}
                  </div>
                  <div className="flex-grow flex flex-col gap-2   rounded-lg p-1 ">
                    <div className="text-h3 text-shadow_50">Rapports</div>
                    {dropped_exists && (
                      <SecondaryButton
                        sx={{
                          backgroundColor: theme.palette.chart.line_blue,
                          color: theme.palette.forever.white,
                        }}
                        className="w-fit h-fit inset-0 shimmer rounded-2xl "
                        onClick={() =>
                          handleTransferFiles("rapport-slot#" + index)
                        }
                        disabled={
                          loadingTransfer !== undefined &&
                          loadingTransfer !== null
                        }
                      >
                        <div>
                          <div className="flex flex-row gap-1 items-center">
                            {loadingTransfer === "rapport-slot#" + index
                              ? "Transfert en cours ..."
                              : "Transférer ici"}
                            <SmallSpinner
                              loading={
                                loadingTransfer === "rapport-slot#" + index
                              }
                              margin={0}
                              size={20}
                            />
                          </div>
                        </div>
                      </SecondaryButton>
                    )}
                    <div className="flex flex-row gap-2 ">
                      <div className="flex w-8 h-fit">
                        <UploadRapportSlot
                          folder={folderData}
                          slot_id={slot.id}
                          onUpdate={handleFetchData}
                          prefix={prefix}
                        ></UploadRapportSlot>
                      </div>

                      {(!slots[index]?.files ||
                        slots[index]?.files?.length === 0) && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Pas de rapports
                        </div>
                      )}
                      {slots[index]?.files?.length > 0 && (
                        <div className=" text-h4  text-shadow_50  w-fit flex flex-col gap-1">
                          {slots[index]?.files?.map((file, index) => (
                            <div
                              className="  border-l-1 border-green-300 rounded-sm px-1"
                              key={index}
                            >
                              {file.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {slots[index]?.files?.length > 0 && (
                      <SlotRapportVisualisateur
                        folder={folderData}
                        userData={userData}
                        slot_id={slots[index].id}
                        orgData={orgData}
                        prefix={prefix}
                        handleUpdate={handleFetchData}
                      ></SlotRapportVisualisateur>
                    )}
                  </div>{" "}
                  <div className="text-h3 text-shadow_50 flex flex-row justify-end w-fit gap-1 ">
                    <div className="flex flex-col gap-2 items-end w-fit">
                      {slots[index]?.state === "unlocked" && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400">
                            Débloqués
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}
                      {slots[index]?.downloaded === true && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400 ">
                            Reçu
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}
                      {slots[index]?.state === "locked" && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-blue-500">
                            Verrouillés
                          </div>
                          <Icon1
                            icon_name="lock"
                            size={18}
                            fill={"#3b82f6"}
                          ></Icon1>
                        </div>
                      )}{" "}
                      <div className="mt-auto flex flex-col gap-2 justify-end items-end ">
                        {slots[index]?.state === "locked" && (
                          <PrimaryButton
                            className="w-fit h-fit mt-auto"
                            onClick={() => handleSetLocked(index)}
                          >
                            Débloquer
                          </PrimaryButton>
                        )}{" "}
                        {slots[index]?.state === "unlocked" && (
                          <SecondaryButton
                            className="w-fit h-fit mt-auto"
                            onClick={() => handleSetLocked(index)}
                          >
                            Verrouiller
                          </SecondaryButton>
                        )}
                        <SecondaryButton
                          onClick={() => {
                            setDeleteOpen(index);
                          }}
                          className={"w-fit h-fit"}
                        >
                          Supprimer
                        </SecondaryButton>{" "}
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
            ))}
            <Space y={2} />
            <div className="flex flex-row gap-2">
              <SecondaryButton
                startIcon={<Icon1 icon_name="plus" size={17} fill={"grey"} />}
                className="w-fit "
                onClick={handleAddSlot}
              >
                Ajouter un emplacement
              </SecondaryButton>
              <SecondaryButton
                className="w-fit "
                onClick={handleSetReglementDone}
              >
                Passer le dossier en{" "}
                {folderData.reglement_state === "done"
                  ? "non finalisé"
                  : "finalisé"}
              </SecondaryButton>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default ReglementConstructor;
